











import { defineClassComponent } from '@/hooks'
import { JointComponents } from '../../components'
import { jointGoodsModelProvider } from '../model'
import { ref } from '@vue/composition-api'

export default defineClassComponent(
  {
    components: JointComponents,
  },
  () =>
    class {
      jointGoodsModel = jointGoodsModelProvider.inject()

      isFold = ref(true)
    },
)
